import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, ShieldCheck } from 'lucide-react';
import { GIISDEC_CONTACT } from '@/lib/contact';
import BrandLogo from '@/components/portal/BrandLogo';

const Footer: React.FC = () => {
  return (
    <footer className="bg-eds-forest text-white/75 border-t border-eds-forest-2 font-eds-body">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <BrandLogo variant="light" className="mb-4" />
          <p className="text-sm text-white/60">
            GIISDEC Geological Information &amp; Investment Platform (GIISDEC GIIP), supporting
            geological information management, GIS-enabled operations, investor services,
            and digital service delivery.
          </p>
        </div>


        <div>
          <h4 className="text-white font-semibold mb-3 text-sm uppercase tracking-wider">Explore</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-eds-mint">Home</Link></li>
            <li><Link to="/about" className="hover:text-eds-mint">About</Link></li>
            <li><Link to="/projects" className="hover:text-eds-mint">Projects</Link></li>
            <li><Link to="/contact" className="hover:text-eds-mint">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-3 text-sm uppercase tracking-wider">Portals</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/investor-login" className="hover:text-eds-mint">Investor Portal</Link></li>
            <li><Link to="/gis" className="hover:text-eds-mint">Public GIS</Link></li>
            <li><Link to="/contact" className="hover:text-eds-mint">Government &amp; Agency Access</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-3 text-sm uppercase tracking-wider">{GIISDEC_CONTACT.head.label}</h4>
          <ul className="space-y-2 text-sm text-white/60">
            <li className="flex items-start gap-2">
              <MapPin className="w-4 h-4 mt-0.5 text-eds-mint flex-shrink-0" />
              <span>{GIISDEC_CONTACT.head.address}</span>
            </li>
            <li className="flex items-start gap-2">
              <Mail className="w-4 h-4 mt-0.5 text-eds-mint flex-shrink-0" />
              <a href={GIISDEC_CONTACT.emailHref} className="hover:text-eds-mint break-all">
                {GIISDEC_CONTACT.email}
              </a>
            </li>
            <li className="flex items-start gap-2">
              <Phone className="w-4 h-4 mt-0.5 text-eds-mint flex-shrink-0" />
              <a href={GIISDEC_CONTACT.phoneHref} className="hover:text-eds-mint">
                {GIISDEC_CONTACT.phoneDisplay}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-eds-forest-2">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-white/50">
          <span>© {new Date().getFullYear()} Ghana Integrated Iron &amp; Steel Development Corporation (GIISDEC). All rights reserved.</span>
          <span className="inline-flex items-center gap-1.5 text-white/60">
            <ShieldCheck className="w-3.5 h-3.5 text-eds-mint" aria-hidden="true" />
            Hosted at the NITA National Data Centre
          </span>
        </div>
      </div>

    </footer>
  );
};

export default Footer;
